import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Modal from 'react-modal';
import { BrowserRouter as Router } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

const BOOT_KEY = "__ESTIASYNC_BOOTSTRAPPED__";

if (window[BOOT_KEY]) {
  console.warn("EstiaSync: bootstrap skipped (already mounted).");
} else {
  window[BOOT_KEY] = true;

  const applyAutoCaps = (el) => {
    if (!el || el.nodeType !== 1) return;
  
    const tag = el.tagName;
    const type = (el.getAttribute("type") || "").toLowerCase();
  
    const isTextInput =
      tag === "INPUT" && (type === "" || type === "text" || type === "search");
    const isTextArea = tag === "TEXTAREA";
  
    if (isTextInput || isTextArea) {
      // HTML attribute is "autocapitalize" (lowercase)
      if (!el.getAttribute("autocapitalize")) {
        el.setAttribute("autocapitalize", "characters");
      }
    }
  };
  
  // Apply once to existing fields
  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll('input[type="text"], input[type="search"], textarea')
      .forEach(applyAutoCaps);
  });
  
  // Apply to any field the moment user interacts/focuses it (covers dynamically added inputs too)
  document.addEventListener("pointerdown", (e) => applyAutoCaps(e.target), true);
  document.addEventListener("focusin", (e) => applyAutoCaps(e.target), true);
  
  // ---- Prevent mobile auto-zoom on input focus (without enlarging fonts) ----
  function setupFocusZoomLock() {
    // Only apply on small screens + iOS-like devices (includes iPadOS on Safari)
    const isSmallScreen = window.matchMedia('(max-width: 599px)').matches;
    const isAppleTouch =
      /iP(ad|hone|od)/i.test(navigator.userAgent) ||
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    if (!isSmallScreen || !isAppleTouch) return;
  
    const BASE = 'width=device-width, initial-scale=1, viewport-fit=cover';
    const LOCK = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover';
  
    const getViewport = () => {
      let m = document.querySelector('meta[name="viewport"]');
      if (!m) {
        m = document.createElement('meta');
        m.setAttribute('name', 'viewport');
        document.head.appendChild(m);
      }
      return m;
    };
  
    let locked = false;
    const lock = () => {
      if (locked) return;
      getViewport().setAttribute('content', LOCK);
      locked = true;
    };
    const unlock = () => {
      if (!locked) return;
      getViewport().setAttribute('content', BASE);
      locked = false;
    };
  
    // Lock zoom on any form control focus; unlock shortly after blur
    document.addEventListener('focusin', (e) => {
      const t = e.target;
      if (!t) return;
      const tag = t.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') lock();
    });
    document.addEventListener('focusout', () => {
      // delay to avoid flicker when focus moves between fields
      setTimeout(unlock, 250);
    });
  }
  
  Modal.setAppElement('#root');
  
  const ROOT_KEY = "__ESTIASYNC_REACT_ROOT__";
  
  const container = document.getElementById("root");
  if (!container) throw new Error("Root element '#root' not found");
  
  // Reuse the same root if this file is executed twice (prevents duplicated UI)
  const root = window[ROOT_KEY] || (window[ROOT_KEY] = ReactDOM.createRoot(container));
  setupFocusZoomLock();
  root.render(
    // Optional: you can remove StrictMode to avoid dev-only double-invocations
    // <React.StrictMode>
      <Router>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </Router>
    // </React.StrictMode>
  );
  
  reportWebVitals();

}
